import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private isSubject = new Subject<any>();

  constructor() { }

  publishData(data: any) {
    // // console.log("data", data);
    this.isSubject.next(data);
  }

  getObservable(): Subject<any> {
    return this.isSubject;
  }

}
